var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisgust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3171 14.607L10.4976 6.57187V2.125H11.1226C11.2883 2.125 11.4473 2.05915 11.5645 1.94194C11.6817 1.82473 11.7476 1.66576 11.7476 1.5C11.7476 1.33424 11.6817 1.17527 11.5645 1.05806C11.4473 0.940848 11.2883 0.875 11.1226 0.875H4.87258C4.70682 0.875 4.54784 0.940848 4.43063 1.05806C4.31342 1.17527 4.24758 1.33424 4.24758 1.5C4.24758 1.66576 4.31342 1.82473 4.43063 1.94194C4.54784 2.05915 4.70682 2.125 4.87258 2.125H5.49758V6.57187L0.678045 14.607C0.564376 14.7965 0.502977 15.0128 0.500106 15.2338C0.497234 15.4547 0.552991 15.6725 0.661696 15.8649C0.770401 16.0573 0.928168 16.2174 1.11892 16.329C1.30967 16.4406 1.52659 16.4996 1.74758 16.5H14.2476C14.4688 16.5 14.686 16.4413 14.8771 16.3299C15.0681 16.2185 15.2262 16.0584 15.3352 15.8659C15.4442 15.6734 15.5002 15.4555 15.4974 15.2343C15.4946 15.0132 15.4332 14.7967 15.3195 14.607H15.3171ZM8.27961 11.2547C7.03664 10.6258 5.85383 10.2922 4.7468 10.2539L6.65851 7.06641C6.71697 6.96952 6.74777 6.85847 6.74758 6.74531V2.125H9.24758V6.74531C9.24738 6.85847 9.27818 6.96952 9.33664 7.06641L12.3226 12.0469C11.3882 12.2297 10.0515 12.1516 8.27961 11.2547Z",
    fill: "url(#paint0_linear_393_82858)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_393_82858",
    x1: 15.4975,
    y1: 0.875,
    x2: -2.75222,
    y2: 9.98484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93BA42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisgust);
export default __webpack_public_path__ + "static/media/Disgust.fc0cf68652074271246e7872c3a441b9.svg";
export { ForwardRef as ReactComponent };